import _, { escape, iteratee } from 'lodash';
import api from '../../api';
import environment from '../../environment';
import { customScrollbar } from '../../shared';
import dialogBox from '../dialog';
import worldMap from '../map';
import templates from '../templates';
import ColorBrewer from '../tools/colorbrewer';
import ColorFlatUI from '../tools/colorflatui';
import googleAnalytics from '../tools/googleanalytics';
import AuthService from '../../../services/authservice';
import translate from '../../core/tools/translate';
import { ControlType, Item } from '../../workspaces/item';
import Workspace from '../../workspaces';
import { ContextEnum } from '../../../enuns/context.enum';
import { SidebarButton } from './button.helper';

const LayerControls = name => require('../../controls').get(name);
const infoBoard = () => require('../infoboard').default;
const compare = () => require('../map/compare').default;

const Sidebar = (() => {
    return {
        _triggerEvent: false,
        _eventCategory: 'Sidebar',

        init(trigger, options) {
            this.trigger = trigger;
            this.options = options;
            this.wrapper = document.getElementById('sidebar-container');

            $(this.wrapper).empty();

            if (!this._triggerEvent) {
                this.visible = false;
                this._triggerEvent = true;
                this._initEvents();
            }
            if (AuthService.isAuthenticated()) {
                this._createMenu();
            } else {
                this.open();
            }
        },

        open() {
            if (!this.visible) {
                return this._openMenu();
            }
        },

        toggle() {
            if (this.visible) {
                return this._closeMenu();
            } else {
                return this._openMenu();
            }
        },

        close() {
            if (this.visible) {
                return this._closeMenu();
            }
        },

        isOpen() {
            return this.visible;
        },

        getControls(id, name) {
            if (name) {
                return this._getVirtualGroupControl(id)[name];
            }

            return this._getVirtualGroupControl(id);
        },

        removeControls(id) {
            if (this._virtualGroupControl.has(id)) {
                this._virtualGroupControl.delete(id);
            }

            this._getVirtualControlGroupId();
        },

        setControls(id) {
            if (!this._virtualGroupControl) return;

            if (this._virtualGroupControl.has(id)) {
                this._setCurrentVirtualGroupControl(id);
            } else {
                this._createVirtualGroupControl();
            }
            this._restoreState();
        },

        copyOptions(originId, destinyId) {
            const originVirtualGroupControl = this._getVirtualGroupControl(originId);
            const destinyVirtualGroupControl = this._getVirtualGroupControl(destinyId);
            _.forEach(originVirtualGroupControl, (val, key) => {
                destinyVirtualGroupControl[key] = val;
            });
            this._restoreState(destinyVirtualGroupControl);
        },

        copyControls(id) {
            if (!this._virtualGroupControl) return;

            if (this._virtualGroupControl.has(id)) {
                this._setCurrentVirtualGroupControl(id);
                this.copyOptions(0, id);
            } else {
                this._createVirtualGroupControl();
                this.copyOptions(0, id);
            }
        },

        _getTemplate(type, values) {
            if (_.isArray(type)) {
                return templates(`${type[0]}-${type[1]}`, values);
            } else {
                return templates(`sidebar-${type}`, values);
            }
        },

        _createMenu() {
            const layers = this._createEntries(this.options);
            this.el = layers;
            $(this.wrapper).append(layers);
            customScrollbar(this.el);
        },

        _initEvents() {
            return $(this.trigger).on('click touchstart', e => {
                e.stopPropagation();
                e.preventDefault();
                this.toggle();
            });
        },

        _openMenu() {
            if (infoBoard().isOpen() && Number($(window).width()) <= 1280) {
                infoBoard().close();
            }

            this.visible = true;
            this._updateMapContainer();
        },

        _closeMenu() {
            if (infoBoard().isOpen() && Number($(window).width()) <= 1280) {
                infoBoard().close();
            }

            this.visible = false;
            this._updateMapContainer();

            if ($('#databoard-container .chart-table').data('kendoGrid')) {
                setTimeout(() => {
                    $('#databoard-container .chart-table')
                        .data('kendoGrid')
                        .refresh();
                }, 500);
            }
        },

        _updateMapContainer() {
            $('#main-pane').toggleClass('sidebar-open', this.visible);

            setTimeout(() => {
                worldMap.refresh();
                if (compare().visible()) {
                    worldMap.get(1).invalidateSize();
                }
            }, 400);
        },

        _setTransform(val, el) {
            $(el).velocity({ translateX: val });
        },

        _createEntries(options) {
            if (!options) return;

            // create main div container
            const div = document.createElement('div');
            div.className = 'panel-group sidebar-level';

            // create options items
            _.forEach(options.entries, entry => {
                if (!entry) return;

                $(div).append(this._getEntryContainer(entry));
            });

            this._createVirtualGroupControl();
            return div;
        },

        _resizeSlider(container) {
            setTimeout(() => {
                const sliders = container.find('[data-role="slider"]');
                sliders.each((index, el) => {
                    const slider = $(el).getKendoSlider();
                    slider.resize();
                });
            }, 500);
        },

        _getEntryContainer(entry) {
            entry.id = entry.name.toLowerCase().replace(/\s+/g, '-');
            entry.imageUrl = environment.get('IMAGES_HOST');

            const container = $(this._getTemplate(entry.type, entry));
            const header = container.find('.panel-heading');

            if (entry.type) {
                this._transformContainerElements(container, entry);
            }

            const content = header.find('.panel-title');
            this._addSwitchButton(content, entry);

            if (_.some(['overview', 'filter', 'purge', 'helpInfo'], p => entry[p])) {
                const btnGroup = $('<div class="btn-group panel-button"></div>');
                $(content).append(btnGroup);

                if (entry.overview) {
                    this._addOverviewButton(btnGroup, entry);
                }

                if (entry.filter) {
                    this._addFilterButton(btnGroup, entry);
                }

                if (entry.helpInfo) {
                    this._addHelpInfoButton(btnGroup, entry);
                }

                // if (entry.purge) {
                //     this._addPurgeButton(btnGroup, entry);
                // }
            }

            const idExpandedMenu = header.find('a').attr('href');

            header.on('click', e => {
                e.preventDefault();
                $(idExpandedMenu).collapse('toggle');
            });

            // fix slider width
            header.one('click', () => {
                this._resizeSlider(container);
            });

            return container;
        },

        _getVectorLayer: layer => {
            return _.isFunction(layer) ? layer() : layer;
        },

        _getVirtualControlGroupId() {
            let id = 0;
            const controls = new Map();
            this._virtualGroupControl.forEach(control => {
                const _id = id++;
                control._id = _id;
                controls.set(_id, control);
            });
            this._virtualGroupControl = controls;
            return id;
        },

        _createVirtualGroupControl() {
            if (!this._virtualGroupControl) {
                this._virtualGroupControl = new Map();
            }

            if (!this._virtualControl) {
                this._virtualControl = new Map();
            }

            const id = this._getVirtualControlGroupId();

            this._virtualGroupControl.set(id, this._getVirtualControlClone());

            return this._setCurrentVirtualGroupControl(id);
        },

        _createVirtualControl(id) {
            if (!this._virtualControl) {
                this._virtualControl = new Map();
            }

            this._virtualControl.set(id, {});
            this._setCurrentVirtualControl(id);
        },

        _getVirtualControlClone() {
            const controls = {};
            this._virtualControl.forEach((val, key) => {
                controls[key] = _.cloneDeep(val);
            });

            return controls;
        },

        _setCurrentVirtualGroupControl(id) {
            if (_.isUndefined(id)) return;

            this._currentVirtualGroupControl = this._getVirtualGroupControl(id);
            this._currentVirtualGroupControl._id = id;

            return this._currentVirtualGroupControl;
        },

        _setCurrentVirtualControl(id) {
            if (_.isUndefined(id)) return;

            this._currentVirtualControl = this._virtualControl.get(id);
            this._currentVirtualControl._id = id;

            return this._currentVirtualControl;
        },

        _updateVirtualControl(control) {
            if (_.isUndefined(control)) return;

            const id = this._currentVirtualControl._id;
            const controls = _.assign({}, this._currentVirtualControl, control);
            delete controls._id;
            return this._addVirtualControl(id, controls);
        },

        _addVirtualGroupControl(id, controls) {
            this._virtualGroupControl.set(id, controls);
            this._setCurrentVirtualGroupControl(id);
            return this._currentVirtualGroupControl;
        },

        _addVirtualControl(id, controls) {
            this._virtualControl.set(id, controls);
            this._setCurrentVirtualControl(id);
            return this._currentVirtualControl;
        },

        _getVirtualGroupControl(id) {
            if (this._virtualGroupControl) {
                if (this._virtualGroupControl.has(id)) {
                    return this._virtualGroupControl.get(id);
                } else if (!_.isUndefined(id)) {
                    this._virtualGroupControl.set(id, this._getVirtualControlClone());
                    return this._virtualGroupControl.get(id);
                }
            }

            return this._currentVirtualGroupControl;
        },

        _getVirtualControl() {
            return this._currentVirtualControl;
        },

        _restoreState(controlsGroup = this._getVirtualGroupControl()) {
            _.forEach(controlsGroup, (controls, name) => {
                if (name === '_id') return;
                _.forEach(controls, (control, type) => {
                    switch (type) {
                        case 'colorpicker':
                        case 'dropdown':
                            _.forEach(control, c => {
                                c.input = $(c.target).getKendoDropDownList();
                                if (c.input && c.index >= 0) {
                                    c.input.select(c.index);
                                }
                            });
                            break;
                        case 'multiselect':
                        _.forEach(control, c => {
                            c.input = $(c.target).getKendoMultiSelect();
                            if (c.input && c.value && c.value.length) {
                                c.input.value(c.value);
                            }
                        });
                        break;

                        case 'link':
                            _.forEach(control, c => {
                                // if (c.target) {
                                //     c.input = $(c.target);
                                // }
                                this._updateLinkText(c.input, c.text, c.title);
                            });
                            break;

                        case 'radio':
                            _.forEach(control, c => {
                                const target = $(c.input).filter((i, e) => e.value === c.value)[0];
                                if (target) {
                                    c.target = target;
                                    $(c.target).iCheck(c.status ? 'check' : 'uncheck');
                                }
                            });
                            break;

                        case 'checkbox':
                            _.forEach(control, c => {
                                if (c.target) {
                                    $(c.target).iCheck(c.status ? 'check' : 'uncheck');
                                }
                            });
                            break;

                        case 'buttonGroup':
                            _.forEach(control, c => {
                                // if (c.target) {
                                //     c.input = $(c.target).getKendoMobileButtonGroup();
                                // }
                                if (c.input && c.index >= 0) {
                                    c.input.select(c.index);
                                }
                            });
                            break;

                        case 'button':
                            _.forEach(control, c => {
                                c.input = $(c.target).getKendoButton();
                                if (c.input && _.isBoolean(c.enable)) {
                                    c.input.enable(c.enable);
                                }
                            });
                            break;

                        case 'slider':
                            _.forEach(control, c => {
                                c.input = $(c.target).getKendoSlider();
                                if (c.input) {
                                    c.input.value(c.value);
                                }
                            });
                            break;

                        case 'switch':
                            _.forEach(control, c => {
                                if (!c.target) {
                                    return;
                                }

                                c.input = $(c.target).getKendoMobileSwitch();

                                if (!c.input) {
                                    c.input = $(c.target);
                                    this._addCheckBoxActions(c);
                                }

                                if (c.status) {
                                    c.input.enable();
                                }

                                c.input.check(c.status || false);
                            });
                            break;
                    }
                });
            });
        },

        _setupDropdow(container, data, options) {
            if (!data) return;

            if (!_.isArray(data)) {
                data = [data];
            }

            _.forEach(data, d => {
                this._createDropdown(container, d, options);
            });
        },

        _setupMuliSelect(container, data, options) {
            if (!data) return;

            if (!_.isArray(data)) {
                data = [data];
            }

            _.forEach(data, d => {
                this._createMultiSelect(container, d, options);
            });
        },

        _setupRange(container, name, type, options) {
            const el = container.find(`#${options.id}-${name}-slider`);
            if (el.length === 0) return;

            this._createSlider(el, name, type, options);
        },

        _setupTypeButton(container, options) {
            const el = container.find(`#${options.id}-buttons-layer`);
            if (el.length === 0) return;

            this._createButton(el, options);
        },

        _setupLinks(container, options) {
            const el = container.find(`#${options.id}-links`);
            if (el.length === 0) return;
            this._createLinks(el, options);
        },

        _setupCheckbox(container, options) {
            const el = container.find(`#${options.id}-checkbox`);
            if (el.length === 0) return;

            this._createCheckbox(el, 'checkbox', null, options);
        },

        _setupPopover(container, options) {
            const el = container.find(`#${options.id}-popover`);
            if (el.length === 0) return;

            this._createPopover(el, options);
        },

        _setupPinSize(container, options) {
            const el = container.find(`#${options.id}-resize`);
            if (el.length === 0) return;

            const data = options.resize;

            this._createCheckbox(el, 'radio', data, options);
        },

        _setupFillColorPicker(container, theme, options) {
            const el = container.find(`#${options.id}-layer-fill-color`);
            if (el.length === 0) return;

            this._createColorPicker(el, 'fill-color', theme, options);
        },

        _setupLineColorPicker(container, theme, options) {
            const el = container.find(`#${options.id}-layer-line-color`);
            if (el.length === 0) return;

            this._createColorPicker(el, 'line-color', theme, options);
        },

        _setupClearPaint(container, options) {
            const el = container.find(`#${options.id}-clear-paint`);
            if (el.length === 0) return;

            if (typeof options.clearPaint === 'function') {
                el.show();
                el.find('.btn-clear-paint').tooltip();
                el.find('.btn-clear-paint').on('click', () => options.clearPaint());
            }
        },

        _transformContainerElements(container, options) {
            this._createVirtualControl(options.name);

            switch (options.type) {
                case 'vector-points':
                    this._setupRange(container, 'range', 'points', options);
                    this._setupDropdow(container, options.dropdown, options);
                    this._setupTypeButton(container, options);
                    this._setupPinSize(container, options);
                    break;

                case 'vector-cluster-heat':
                    this._setupRange(container, 'range', 'points', options);
                    this._setupTypeButton(container, options);
                    break;

                case 'vector-cluster-heat-area':
                    this._setupRange(container, 'range', 'points', options);
                    this._setupDropdow(container, options.dropdown, options);
                    this._setupFillColorPicker(container, ColorBrewer, options);
                    this._setupTypeButton(container, options);
                    break;

                case 'vector-layer':
                    this._setupRange(container, 'opacity', 'polygons', options);
                    break;

                case 'vector-layers':
                    this._setupRange(container, 'opacity', 'polygons', options);
                    this._setupDropdow(container, options.dropdown, options);
                    break;

                case 'vector-layers-extended':
                case 'vector-layers-voronoi':
                    this._setupRange(container, 'line-weight', 'line', options);
                    this._setupRange(container, 'opacity', 'polygons', options);
                    this._setupRange(container, 'range', 'change', options);
                    this._setupDropdow(container, options.dropdown, options);
                    this._setupMuliSelect(container, options.multiselect, options);
                    this._setupFillColorPicker(container, ColorBrewer, options);
                    this._setupLineColorPicker(container, ColorFlatUI, options);
                    break;

                case 'vector-layers-service-area':
                    this._setupRange(container, 'line-weight', 'line', options);
                    this._setupRange(container, 'opacity', 'opacity', options);
                    this._setupCheckbox(container, options);
                    this._setupFillColorPicker(container, ColorBrewer, options);
                    this._setupLineColorPicker(container, ColorFlatUI, options);
                    this._setupClearPaint(container, options);
                    break;

                case 'raster-maps':
                    this._setupDropdow(container, options.dropdown, options);
                    break;

                case 'vector-range':
                    this._setupRange(container, 'range', 'points', options);
                    break;
            }

            this._setupCheckbox(container, options);
            this._setupLinks(container, options);
            this._setupPopover(container, options);
        },

        _replaceTemplateValue(template, value) {
            const re = new RegExp('#:value#', 'g');
            return String(template).replace(re, value);
        },

        _updateLinkText(el, text, title) {
            if (el.text().indexOf('#:value#') > -1) {
                el.html(this._replaceTemplateValue(el.text(), `<a data-target=\"#\">${text}</a>`));
            } else {
                el.find('a').html(text);
            }

            if ((title || el.text()).indexOf('#:value#') > -1) {
                el.attr({ title: this._replaceTemplateValue(title || el.text(), text) });
            } else {
                el.attr({ title: title || text });
            }
        },

        _dialog(el, option, cb) {
            const $text = el.find('.extra-text');
            this._updateLinkText($text, option.text, option.title);
            const link = $text.find('a');
            const eventName = `${el.prop('id')}-dialog-date`;
            const onClick = () => {
                cb();
                Workspace.addAction(new Item(eventName, '', ControlType.GlobalEvent));
            };

            link.on('click', onClick);

            $(document).off(eventName);
            $(document).on(eventName, onClick);

            return link;
        },

        _onLinkChange(options, option, content, name) {
            const setValue = (text, value) => {
                const control = this._getVirtualGroupControl()[options.name][name];
                control[option.name].text = text;
                control[option.name].value = value;
            };

            const getValue = () => {
                const control = this._getVirtualGroupControl()[options.name][name];
                return control[option.name].value;
            };

            const $text = content.find('.extra-text');

            return () => {
                const cb = (text, value) => {
                    value = value || text;
                    setValue(text, value);
                    this._updateLinkText($text, text, option.title);
                    try {
                        if (_.size(content.find('input'))) {
                            const checked = content.find('input').is('checked');
                            option.change(checked, value);
                        } else {
                            option.change(value);
                        }
                    } catch (err) {
                        console.error(err);
                    }
                };

                if (option.type === 'datepicker') {
                    dialogBox.datepicker(getValue(), option, cb);
                } else if (option.dataSource) {
                    dialogBox.select(option.dataSource, cb);
                }
            };
        },

        _createLinks(container, options) {
            const virtualControl = this._getVirtualControl().link || {};

            const _create = option => {
                const content = container.find(`[data-name="${option.name}"]`).closest('.actions-checkbox');
                const onChance = this._onLinkChange(options, option, content, 'link');

                virtualControl[option.name] = {
                    title: option.title,
                    text: option.text || option.value,
                    value: option.value,
                    input: content
                };

                this._dialog(content, option, onChance);
            };

            _.forEach(options.links, l => _create(l));

            this._updateVirtualControl({ link: virtualControl });
        },

        _createCheckbox(container, name, data, options) {
            const virtualControl = this._getVirtualControl()[name] || {};

            const _create = option => {
                const el = container.find(`input[name="${option.name}"]`);
                const key = _.camelCase(option.name);

                virtualControl[key] = {
                    status: false,
                    value: option.link ? option.link.value : option.value,
                    input: el
                };

                const setState = (target, state, value) => {
                    const control = this._getVirtualGroupControl()[options.name][name][key];
                    control.target = target;
                    control.status = state;
                    control.value = value;
                };

                el.iCheck({
                    checkboxClass: 'icheckbox_square-blue',
                    radioClass: 'iradio_square-blue'
                });

                el.each((i, e) => {
                    virtualControl[key].target = e;
                    virtualControl[key].status = e.checked;
                    virtualControl[key].value = e.value;
                });

                if (option.visible === false) {
                    $(el).closest('.actions-checkbox').hide();
                }

                if (option.help) {
                    container.find(`[data-help="${option.name}"]`).popover({
                        trigger: 'hover focus',
                        container: 'body',
                        placement: 'right',
                        content: option.help
                    });
                }

                if (option.style && option.style.click) {
                    container.find(`button[name="${option.name}"]`).on('click', option.style.click);
                }

                if (option.style && !option.style.isColor && !option.style.click) {
                    const styleButton = container.find(`button[name="${option.name}"]`);
                    const eventName = `${options.name.toLowerCase()}-checkbox-${option.name}`;
                    const eventClick = e => {
                        dialogBox.textStyle(name, option.style, this._getVectorLayer(options.layer));
                        Workspace.addAction(new Item(eventName, '', ControlType.GlobalEvent));
                    };

                    styleButton.on('click', eventClick);

                    $(document).off(eventName);
                    $(document).on(eventName, eventClick);
                }

                if (option.style && option.style.isColor) {
                    $(el).closest('.extra-checkbox').remove();
                    const styleButton = container.find(`button[name="${option.name}"]`);
                    const eventClick = () => {
                        const $dialog = $('<div id="sidebar-color-dialog" style="width: 140px !important; margin-top: 10px;"></div>');

                        const _colorCanvas = theme => {
                            const canvas = document.createElement('canvas');
                            canvas.width = 90;
                            canvas.height = 20;
                            const ctx = canvas.getContext('2d');
                            _.forEach(theme, (c, i) => {
                                ctx.beginPath();
                                const x = (i * canvas.width) / theme.length;
                                ctx.rect(x, 0, canvas.width / theme.length, 20);
                                ctx.fillStyle = c;
                                ctx.fill();
                            });
                            return canvas.toDataURL('image/png');
                        };

                        const dataSource = _(ColorFlatUI)
                            .transform((result, theme, text) => {
                                if (_.isObject(theme)) {
                                    _.forEach(theme, colors =>
                                        result.push({
                                            text,
                                            value: colors[0],
                                            template: _colorCanvas(colors)
                                        })
                                    );
                                }
                            }, [{
                                text: 'black',
                                value: '#000000',
                                template: _colorCanvas(['#000'])
                            }])
                            .value();

                        const $select = $('<select name="color" style="width: 100% !important;"></select>');
                        $dialog.append($select);

                        $select.kendoDropDownList({
                            dataTextField: 'text',
                            dataValueField: 'value',
                            valueTemplate: `<img style="height: 27px; margin: -2px 0 0 -8px;" src="#: data.template #">`,
                            template: `<img style="margin: 0 0 0 -5px" src="#: data.template #">`,
                            dataSource,
                            index: 0,
                            change: e => {
                                const color = e.sender.value();
                                if (option.style && typeof option.style.change === 'function') {
                                    option.style.change({ color });
                                }
                                $kendoDialog.close();
                            },
                        });

                        const $kendoDialog = $dialog.kendoWindow({
                            width: '150px',
                            title: 'Selecione Cor',
                            visible: false,
                            modal: true,
                            close: () => $dialog.remove()
                        }).data('kendoWindow');

                        $kendoDialog.center().open();
                    };

                    styleButton.on('click', eventClick);
                }

                if (option.link) {
                    option.link.name = option.name;
                    option.link.change = option.link.change || option.change;
                    this._createLinks(container, { name: options.name, links: [option.link] });
                    el.on('ifToggled', e => {
                        const target = e.target;
                        const status = e.target.checked;
                        const value = this._getVirtualGroupControl()[options.name].link[option.name].value;
                        setState(target, status, value);
                        googleAnalytics.trackEventGA(options.name, `${key}`, this._eventCategory, status);
                        option.change(status, value);

                        Workspace.addAction(new Item(`#${options.name.toLowerCase()}-checkbox input[name=${option.name}]`, status, ControlType.ICheckBox));
                    });
                } else {
                    el.on('ifToggled', e => {
                        const target = e.target;
                        const status = e.target.checked;
                        if (option.type === 'radio') {
                            const value = e.target.value;
                            setState(target, status, value);
                            if (status) {
                                Workspace.addAction(new Item(`#${options.name.toLowerCase()}-resize input[name=${option.name}]`, { checked: status, value }, ControlType.ICheckRadio));
                                option.change(value);
                            }
                        } else {
                            setState(target, status);
                            option.change(status);
                            Workspace.addAction(new Item(`#${options.name.toLowerCase()}-checkbox input[name=${option.name}]`, status, ControlType.ICheckBox));
                        }
                        googleAnalytics.trackEventGA(options.name, `${key}`, this._eventCategory, status);
                    });
                }
            };

            if (data) {
                _create(data);
            } else {
                _.forEach(options.checkbox, l => _create(l));
            }

            this._updateVirtualControl({ [name]: virtualControl });
        },

        _createButton(container, options) {
            const layer = this._getVectorLayer(options.layer);
            const virtualControl = this._getVirtualControl().buttonGroup || {};
            const key = 'layerType';

            const index = (() => {
                switch (layer.checkType()) {
                    case 'decluster':
                        return 2;
                    case 'cluster_area':
                    case 'cluster':
                        return 1;
                    default:
                        return 0;
                }
            })();

            const getType = i => $(container.find('li')[i]).data('name');

            const onSelect = e => {
                googleAnalytics.trackEventGA(options.name, key, this._eventCategory);

                const vectorLayer = this._getVectorLayer(options.layer);
                const slider = this._getVirtualGroupControl()[options.name].slider.range.input;
                const control = this._getVirtualGroupControl()[options.name].buttonGroup || {};
                control[key].index = e.index;
                control[key].type = getType(e.index);

                const opt = {
                    controlRange: slider.value(),
                    type: getType(e.index)
                };

                slider.enable(true);
                opt.controlRange = 5;
                slider.value(5);

                api.general.log.action(environment._getContextEnum(options.name), `Pin - ${opt.type}`);
                if (opt.type === 'decluster') {
                    opt.controlRange = 0.25;
                    slider.value(0);
                    slider.disable(true);
                    if (vectorLayer.checkType('default')) return;
                } else if (opt.type === 'cluster') {
                    const value = Math.pow(2, slider.value());
                    opt.controlRange = value;
                    if (vectorLayer.checkType('cluster') && vectorLayer.options.controlRange === value) return;
                } else {
                    opt.controlRange = slider.value() * 7;
                    if (vectorLayer.checkType(opt.type)) return;
                }

                vectorLayer.setOptions(opt);

                const controls = LayerControls(options.name);

                if (controls.check()) {
                    if (_.isFunction(controls.show)) {
                        controls.show({ refresh: true, empty: true });
                    }
                    vectorLayer.reload();
                }

                Workspace.addAction(new Item(`#${$(container).prop('id')}`, e.index, ControlType.KendoMobileButtonGroup));
            };

            const buttonGroup = $(container)
                .kendoMobileButtonGroup({
                    select: onSelect,
                    index
                })
                .data('kendoMobileButtonGroup');

            virtualControl[key] = {
                input: buttonGroup,
                type: getType(index),
                index
            };

            this._updateVirtualControl({ buttonGroup: virtualControl });
        },

        _createDropdown(container, data, options) {
            const el = container.find(`#${options.id}-${data.name}-dropdown`);
            const key = data.name;

            const dataSource = _.isArray(data.dataSource)
                ? data.dataSource
                : _.map(data.dataSource, (value, text) => ({ text, value }));

            const virtualControl = this._getVirtualControl().dropdown || {};

            if (_.some(dataSource)) {
                virtualControl[key] = {
                    index: data.index || 0,
                    target: el,
                    text: dataSource[data.index || 0].text,
                    value: dataSource[data.index || 0].value
                };
            }

            $(document).ready(() => {
                const virtualControlReady = this._getVirtualGroupControl()[options.name].dropdown;

                if (!virtualControlReady[key]) {
                    return;
                }

                virtualControlReady[key].input = el
                    .kendoDropDownList({
                        dataTextField: 'text',
                        dataValueField: 'value',
                        dataSource,
                        index: data.index || 0,
                        enable: _.isBoolean(data.enable) ? data.enable : true,
                        change: e => {
                            const control = this._getVirtualGroupControl()[options.name].dropdown;
                            control[key].index = e.sender.select();
                            control[key].text = e.sender.text();
                            control[key].value = e.sender.value();
                            googleAnalytics.trackEventGA(
                                options.name,
                                `DropDown - ${e.sender.value()}`,
                                this._eventCategory
                            );
                            if ((e.sender.value() === 'None' || Number(e.sender.value()) === 0) && data.disable) {
                                data.disable();
                            } else {
                                data.change(e.sender.value(), e.sender.text());
                            }

                            Workspace.addAction(new Item(`#${options.name.toLowerCase()}-collapse-sidebar #${e.sender.element.prop('id')}`, e.sender.value(), ControlType.KendoDropDownList));
                        }
                    })
                    .data('kendoDropDownList');

                try {
                    if (typeof (data.visible) !== 'undefined' && !data.visible) {
                      virtualControlReady[key].input.wrapper.hide();
                    }

                    virtualControlReady[key].input.list.width(198);
                } catch (err) {
                    console.error(err);
                }
            });

            this._updateVirtualControl({ dropdown: virtualControl });
        },

        _createMultiSelect(container, data, options) {
            const el = container.find(`#${options.id}-${data.name}-multiselect`);
            const key = data.name;

            const dataSource = _.isArray(data.dataSource)
                ? data.dataSource
                : _.map(data.dataSource, (value, text) => ({ text, value }));

            const virtualControl = this._getVirtualControl().multiselect || {};

            if (_.some(dataSource)) {
                virtualControl[key] = {
                    index: data.index || 0,
                    target: el,
                    text: dataSource[data.index || 0].text,
                    value: dataSource[data.index || 0].value
                };
            }

            $(document).ready(() => {
                const virtualControlReady = this._getVirtualGroupControl()[options.name].multiselect;

                if (!virtualControlReady[key]) {
                    return;
                }

                virtualControlReady[key].input = el
                    .kendoMultiSelect({
                        dataTextField: 'text',
                        dataValueField: 'value',
                        dataSource,
                        enable: _.isBoolean(data.enable) ? data.enable : true,
                        placeholder: data.placeholder,
                        change: e => {
                            const control = this._getVirtualGroupControl()[options.name].multiselect;
                            control[key].value = e.sender.value();
                            googleAnalytics.trackEventGA(
                                options.name,
                                `Multiselect - ${e.sender.value()}`,
                                this._eventCategory
                            );
                            if ((e.sender.value() === 'None' || Number(e.sender.value()) === 0) && data.disable) {
                                data.disable();
                            } else {
                                data.change(e.sender.value());
                            }

                            Workspace.addAction(new Item(`#${options.name.toLowerCase()}-collapse-sidebar #${e.sender.element.prop('id')}`, e.sender.value(), ControlType.KendoMultiselect));
                        }
                    })
                    .data('kendoMultiSelect');

                try {
                    if (typeof (data.visible) !== 'undefined' && !data.visible) {
                      virtualControlReady[key].input.wrapper.hide();
                    }
                } catch (err) {
                    console.error(err);
                }
            });

            this._updateVirtualControl({ multiselect: virtualControl });
        },

        _createSlider(el, name, type, options) {
            const key = _.camelCase(name);

            const virtualControl = this._getVirtualControl().slider || {};
            virtualControl[key] = {
                target: el,
                value: 1
            };

            const _changePointsValue = e => {
                let value;
                const vectorLayer = this._getVectorLayer(options.layer);

                // calculate the size of the cluster based window width
                if (vectorLayer.checkType(['cluster', 'cluster_area'])) {
                    value = Math.pow(2, e.value);
                } else {
                    value = e.value * 7;
                }

                if (vectorLayer.options.controlRange === value) return;

                vectorLayer.setOptions({ controlRange: value });

                if (vectorLayer.visible()) {
                    vectorLayer.reload();
                }
            };

            const _changePolygonsValue = e => {
                let value;
                const vectorLayer = this._getVectorLayer(options.layer);

                if (vectorLayer) {
                    if (vectorLayer.checkType('heat')) {
                        value = e.value * 7;
                        vectorLayer.heat.setOptions({ radius: value });
                    } else {
                        value = e.value / 10;
                        if (
                            vectorLayer.options.symbology.type === 'uniq' ||
                            vectorLayer.options.symbology.type === 'range'
                        ) {
                            _.forEach(vectorLayer.options.symbology.values, style => {
                                style.style.fillOpacity = value;
                            });
                        } else {
                            vectorLayer.options.symbology.style.fillOpacity = value;
                        }

                        if (vectorLayer instanceof L.VectorLayer.GeoJSONLayer && vectorLayer.layer) {
                            _.forEach(vectorLayer.layer.getLayers(), l => {
                                if (_.isFunction(l.setStyle)) {
                                    l.setStyle({ fillOpacity: value });
                                }
                            });
                        } else if (vectorLayer.visible()) {
                            vectorLayer.reload();
                        }
                    }

                    vectorLayer.setOptions({ controlRange: value });
                }
            };

            const _changeLineValue = e => options.lineWeight.change(e.value);

            const _changeImagesValue = e => {
                const vectorLayer = this._getVectorLayer(options.layer);
                if (vectorLayer) {
                    vectorLayer.layer.setOpacity(e.value / 100);
                }
            };

            const _changeDataValue = e =>  options.range.change(e.value);

            $(document).ready(() => {
                const virtualControlReady = this._getVirtualGroupControl()[options.name].slider;

                virtualControlReady[key].input = el
                    .kendoSlider({
                        min: 0,
                        max: 10,
                        value: 5,
                        smallStep: 1,
                        largeStep: 10,
                        showButtons: false,
                        enable: !options.disableSlider,
                        change: e => {
                            const control = this._getVirtualGroupControl()[options.name].slider;

                            control[key].value = e.value;

                            googleAnalytics.trackEventGA(options.name, `Slider:${type}`, this._eventCategory, e.value);

                            if (Number(e.value) === 0) {
                                e.value = 0.25;
                            }

                            switch (type) {
                                case 'points':
                                    _changePointsValue(e);
                                    break;
                                case 'polygons':
                                    _changePolygonsValue(e);
                                    break;
                                case 'line':
                                    _changeLineValue(e);
                                    break;
                                case 'image':
                                    _changeImagesValue(e);
                                    break;
                                case 'opacity':
                                    if (options.opacity && options.opacity.change) {
                                        options.opacity.change(e.value);
                                    }
                                    break;
                                default:
                                    _changeDataValue(e);
                            }

                            Workspace.addAction(new Item(`#${$(el).prop('id')}`, e.value, ControlType.KendoSlider));
                        }
                    })
                    .data('kendoSlider');
            });

            this._updateVirtualControl({ slider: virtualControl });
        },

        _addPurgeButton(container, options) {
            // create checkbox
            const input = $(
                `<button class="btn-xs btn-circle btn-option" type="button" title="Desfazer alterações">
                     <i class="fa fa-eraser" aria-hidden="true"></i>
                 </button>`
            );

            $(container).append(input);

            this._createPanelButton(input, 'purge', options);
        },

        _addFilterButton(container, options) {
            // create checkbox
            const input = $(
                `<button class="btn-xs btn-circle btn-option" type="button" title="Filtro de Dados">
                     <i class="fa fa-filter" aria-hidden="true"></i>
                 </button>`
            );

            $(container).append(input);

            this._createPanelButton(input, 'filter', options);
        },

        _addOverviewButton(container, options) {
            // create checkbox
            const input = $(
                `<button
                    class="btn-xs btn-circle btn-option"
                    type="button"
                    title="${translate(`Common.DisplayCharts`)}">
                     <i class="fa fa-bar-chart" aria-hidden="true"></i>
                 </button>`
            );

            $(container).append(input);

            this._createPanelButton(input, 'overview', options);
        },

        _addHelpInfoButton(container, options) {
            const rawText = options.helpInfo.trim();
            const content = rawText.replace(/\n/g, '<br>');

            const input = $(`
                <button
                    id="${options.id}-popover"
                    class="btn-circle btn-option btn-xs k-button"
                    data-toggle="popover"
                    data-trigger="hover focus"
                    data-container="body"
                    data-placement="right">
                    <i class="fa fa-info"></i>
                </button>
            `);

            $(container).append(input);

            input.popover({
                trigger: 'hover focus',
                container: 'body',
                placement: 'right',
                html: true,
                content
            });
        },

        _createPopover(el, options) {
            const virtualControl = this._getVirtualControl().button || {};
            const key = 'popover';

            virtualControl[key] = {
                target: el
            };

            $(el).on('click', e => {
                e.stopPropagation();
                e.preventDefault();
            });

            $(document).ready(() => {
                el.popover();
            });

            this._updateVirtualControl({ button: virtualControl });
        },

        _createPanelButton(el, name, options) {
            const virtualControl = this._getVirtualControl().button || {};
            const enable = name === 'purge' || (_.isObject(options[name]) && options[name].enable);
            const idElement = `${options.id}_${name}`;

            $(el).prop('id', idElement);

            virtualControl[name] = {
                target: el,
                enable
            };

            const onClick = (evt) => {
                googleAnalytics.trackEventGA(options.name, name, this._eventCategory);
                _.isFunction(options[name]) ? options[name]() : options[name].click && options[name].click();
                Workspace.addAction(new Item(`#${idElement}`, '', ControlType.KendoButton));

                SidebarButton.controlActiveButton(idElement, name);
            };

            $(el).on('click', e => {
                e.stopPropagation();
                e.preventDefault();
            });

            $(document).ready(() => {
                const control = this._getVirtualGroupControl()[options.name].button;

                control[name].input = el
                    .kendoButton({
                        enable: false,
                        click: onClick
                    })
                    .data('kendoButton');
            });

            this._updateVirtualControl({ button: virtualControl });
        },

        _addSwitchButton(container, options) {
            const virtualControl = this._getVirtualControl().switch || {};
            virtualControl.onOff = {
                status: options.checked || false
            };

            if (options.input) {
                const div = $('<div class="panel-switch"></div>');
                const input = $('<input class="checkbox" type="checkbox">');

                virtualControl.onOff.target = input;

                if (options.checked) {
                    $(input).attr('checked', true);
                }
                if (options.disabled) {
                    $(input).attr('disabled', true);
                }
                if (options.name) {
                    $(input).attr('name', `${options.name}-switch`);
                }
                if (options.id) {
                    $(input).attr('id', options.id);
                }

                $(div).append(input);
                $(container).append(div);

                $(div).on('click', e => e.stopPropagation());

                $(document).ready(() => {
                    this._setSwitchButton(input, options);
                });
            } else if (options.change) {
                $(container).on('click', e => {
                    e.status = !e.status;
                    e.checked = e.status;
                    const control = this._getVirtualGroupControl()[options.name].switch;
                    control.onOff.status = e.checked;
                    options.change(e);
                });
            }

            this._updateVirtualControl({ switch: virtualControl });
        },

        _setSwitchButton(input, options) {
            const virtualControl = this._getVirtualGroupControl()[options.name].switch;

            switch (options.input) {
                case 'switch':
                    virtualControl.onOff.input = $(input)
                        .kendoMobileSwitch({
                            onLabel: `<i class='fa fa-check'></i>`,
                            offLabel: `<i class='fa fa-times'></i>`,
                            change: e => {
                                const control = this._getVirtualGroupControl()[options.name].switch;
                                control.onOff.status = e.checked;
                                googleAnalytics.trackEventGA(options.name, 'Toogle', this._eventCategory, e.checked);
                                infoBoard().toggleContext(options);
                                options.change(e);
                            }
                        })
                        .data('kendoMobileSwitch');
                    break;

                default:
                    virtualControl.onOff.input = $(input);

                    virtualControl.onOff.input.iCheck({
                        checkboxClass: 'icheckbox_square-blue',
                        radioClass: 'icheckbox_square-blue',
                        increaseArea: '10%'
                    });

                    if (options.change) {
                        virtualControl.onOff.input.on('ifToggled', e => {
                            Workspace.addAction(new Item(`#${e.target.id}`, e.target.checked, ControlType.ICheckBox));
                            const control = this._getVirtualGroupControl()[options.name].switch;
                            control.onOff.status = e.target.checked;
                            infoBoard().toggleContext(options);
                            options.change(e.target);
                        });
                    }

                    this._addCheckBoxActions(virtualControl.onOff);
            }
        },

        _addCheckBoxActions(virtualControl) {
            virtualControl.input.check = val => {
                if (_.isBoolean(val)) {
                    virtualControl.input.iCheck(val ? 'check' : 'uncheck');
                } else {
                    return virtualControl.status;
                }
            };

            virtualControl.input.enable = val => {
                if (_.isBoolean(val)) {
                    virtualControl.input.iCheck(val ? 'enable' : 'disable');
                }
                virtualControl.input.iCheck('enable');
            };
        },

        // END: _addSwitchButton: (title, options, container) ->
        _createColorPicker(el, name, themes, options) {
            const key = _.camelCase(name);
            const virtualControl = this._getVirtualControl().colorpicker || {};

            const _colorCanvas = theme => {
                const canvas = document.createElement('canvas');
                canvas.width = 44;
                canvas.height = 34;
                const ctx = canvas.getContext('2d');
                _.forEach(theme, (c, i) => {
                    ctx.beginPath();
                    const x = (i * canvas.width) / theme.length;
                    const y = 0;
                    ctx.rect(x, y, canvas.width / theme.length, canvas.height);
                    ctx.fillStyle = c;
                    ctx.fill();
                });
                return canvas.toDataURL('image/png');
            };

            const data = _(themes)
                .transform((result, theme, text) => {
                    if (_.isObject(theme)) {
                        _.forEach(theme, (colors, range) =>
                            result.push({
                                text: text,
                                value: `${text}:${range}`,
                                template: _colorCanvas(colors)
                            })
                        );
                    }
                }, [])
                .value();

            virtualControl[key] = {
                value: data[0].value,
                text: data[0].text,
                target: el
            };

            $(document).ready(() => {
                const virtualControlReady = this._getVirtualGroupControl()[options.name].colorpicker;

                virtualControlReady[key].input = el
                    .kendoDropDownList({
                        dataTextField: 'text',
                        dataValueField: 'value',
                        dataSource: data,
                        enable: true,
                        valueTemplate: `<img style="width:16px; height:16px;" class="layer-${name}-selected" src="#: data.template #">`,
                        template: `<img style="margin: 0 0 0 -5px" src="#: data.template #">`,
                        index: 0,
                        change: e => {
                            const control = this._getVirtualGroupControl()[options.name].colorpicker;
                            control[key].index = e.sender.select();
                            control[key].text = e.sender.text();
                            control[key].value = e.sender.value();
                            Workspace.addAction(new Item(`#${e.sender.element.prop('id')}`, e.sender.value(), ControlType.KendoDropDownList));
                            if (name === 'fill-color') {
                                return options.fillColor.change(e.sender.value());
                            } else {
                                return options.lineColor.change(e.sender.value());
                            }
                        }
                    })
                    .data('kendoDropDownList');

                try {
                    virtualControlReady[key].input.list.width(62);
                } catch (err) {
                    console.error(err);
                }
            });

            this._updateVirtualControl({ colorpicker: virtualControl });
        }
    };
})();

export default Sidebar;



// WEBPACK FOOTER //
// ./src/scripts/core/sidebar/index.js